<template>
  <div>
    <div class="d-flex">
      <v-text-field
        v-model="filterParams.search"
        label="Search"
        solo
        dense
        height="40"
        :class="searchClass"
        clearable
        id="search"
        prepend-inner-icon="mdi-magnify"
        @change="throttledMethod()"
        @keyup.enter="throttledMethod()"
        @click:append="clearSearch()"
        @click:clear="clearSearch()"
      />
      <v-select
        v-model="filterParams.searchType"
        label="Type"
        solo
        v-if="searchTypes.length"
        :style="typeStyle"
        hide-details
        dense
        id="search-type"
        :disabled="_loading"
        clearable
        class="mt-6 mr-4"
        :items="searchTypes"
      ></v-select>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import MobileView from '@/mixins/MobileView';
import FilterParams from '@/mixins/FilterParams';

export default {
  mixins: [MobileView, FilterParams],
  props: ['headers', 'searchTypes'],
  data() {
    return {
      searchTypeChosen: undefined,
      typeNotSet: false,
      searchFocused: false,
    };
  },
  computed: {
    searchClass() {
      if (!this.showMobileView && this.headers) {
        return '';
      }
      return 'mt-6 mr-4 ml-1';
    },
    ...mapGetters({
      _tab: 'reconciliation/getTab',
      _loading: 'loading/getLoading',
    }),
    defaultSearchSelect() {
      return this.filterParams.searchType;
    },
    typeStyle() {
      if (this.showMobileView) {
        return 'width:38%;';
      }
      return '';
    },
  },
  beforeUpdate() {
    if (
      this.filterParams.searchType
      && this.searchTypes
      && (!this.filterParams.searchType
        || !this.searchTypes.includes(this.filterParams.searchType))
    ) {
      this.filterParams.searchType = this.searchTypes ? this.searchTypes[0] : 0;
    }
  },
  mounted() {
    this.throttledMethod = _.debounce(() => {
      this.setSearch();
    }, 250);
  },
  methods: {
    ...mapActions({
      _getKeyData: 'digitalKeys/acquireData',
      _getGroupData: 'groups/acquireGroups',
      _getScreenData: 'screens/getAllScreensData',
      _getReconciliationReturnData: 'reconciliation/acquireRentalData',
      _getReconciliationOneWayData: 'reconciliation/acquireOneWayData',
      _getReportInstances: 'reports/acquireSessions',
      _getReportGroups: 'reports/acquireGroups',
    }),
    setSearch() {
      if (!this.filterParams.searchType) {
        this.typeNotSet = true;
        this.filterParams.searchType = this.searchTypes[0];
      } else {
        this.typeNotSet = false;
      }
    },
    clearSearch() {
      this.filterParams.search = '';
      this.setSearch();
    },
    checkSearch() {
      if (this.filterParams.search !== '') {
        this.throttledMethod();
      }
    },
  },
  watch: {
    _loading() {
      const active = document.activeElement;
      if (active.id === 'search') {
        active.disabled = this._loading;
        this.searchFocused = true;
      } else {
        document.getElementById('search').disabled = false;
        if (this.searchFocused) {
          this.searchFocused = false;
          document.getElementById('search').focus();
        }
      }
    },
  },
};
</script>
